<template>
    <div id="add-block-menu">
        <BlockSearch />
        <BlockList :block="AIBlock" :blockSecond="traditionalBlock" menu-title="Controls" show-submenu-icon v-show="isLeftColumn('controlBlocks')" />
        <BlockList :block="legacyAIToolBlock" :blockSecond="legacyTraditionalBlock" menu-title="Legacy Tools" v-show="isLeftColumn('legacyBlocks')" />
        <BlockList :block="creativeBlock" v-show="isLeftColumn('creativeBlocks')" />
        <BlockList :block="magicModeBlock" :blockSecond="legacyMagicModeBlock" v-show="isLeftColumn('magicModeBlocks')" />
        <ProductsList v-show="isLeftColumn('products')" />
        <LayoutsList v-show="isLeftColumn('layouts')" />
    </div>
</template>

<script>
import config from '@/assets/js/config/Config'
import ProductsList from "@/components/app/blocks/ProductsList.vue";
import LayoutsList from "@/components/app/layouts/LayoutsList.vue";
import BlockList from "@/components/app/blocks/BlockList.vue";
import BlockSearch from "@/components/app/blocks/BlockSearch.vue";
import { mapGetters, mapState } from "vuex";

export default {
    components: {
        BlockList,
        LayoutsList,
        ProductsList,
        BlockSearch
    },
    computed: {
        ...mapGetters('UI', ['isLeftColumn']),
        ...mapState('UI', ['blockListSearchTerm', 'filteredBlockList']),
        AIBlock() {
            if (this.blockListSearchTerm) return this.filteredBlockList.find(blockType => blockType.type == 'AIControls');
            else return config.blocks.find(blockType => blockType.type == 'AIControls');
        },

        legacyAIToolBlock() {
            if (this.blockListSearchTerm) return this.filteredBlockList.find(blockType => blockType.type == 'legacy-ai-tools');
            else return config.blocks.find(blockType => blockType.type == 'legacy-ai-tools');
        },

        legacyTraditionalBlock() {
            if (this.blockListSearchTerm) return this.filteredBlockList.find(blockType => blockType.type == 'legacy-traditional-tools');
            else return config.blocks.find(blockType => blockType.type == 'legacy-traditional-tools');
        },

        traditionalBlock() {
            if (this.blockListSearchTerm) return this.filteredBlockList.find(blockType => blockType.type == 'TraditionalControls');
            else return config.blocks.find(blockType => blockType.type == 'TraditionalControls');
        },

        creativeBlock() {
            if (this.blockListSearchTerm) return this.filteredBlockList.find(blockType => blockType.type == 'creative');
            else return config.blocks.find(blockType => blockType.type == 'creative');
        },

        magicModeBlock() {
            if (this.blockListSearchTerm) return this.filteredBlockList.find(blockType => blockType.type == 'magic-mode');
            else return config.blocks.find(blockType => blockType.type == 'magic-mode');
        },

        legacyMagicModeBlock() {
            if (this.blockListSearchTerm) return this.filteredBlockList.find(blockType => blockType.type == 'legacy-magic-mode');
            else return config.blocks.find(blockType => blockType.type == 'legacy-magic-mode');
        },
    }
}
</script>

<style lang="scss" scoped>
#add-block-menu {
    color: var(--font-default-color);
    display: grid;
    grid-template-rows: auto minmax(0, 100%);
    z-index: 1;

    ::v-deep .block-type-container {
		position: relative;
        padding: 25px 0;
        display: grid;
        height: 100%;
        grid-template-rows: auto minmax(0, 100%);
        align-content: flex-start;
        margin-bottom: -10px;
        animation-duration: 0.15s;
        animation-fill-mode: forwards;

        &--filtered {
            height: initial;

            .block-type-container--inner {
                overflow: initial;
                height: initial;
            }
        }

        &--inner {
            overflow-x: hidden;
            overflow-y: scroll;
            height: 100%;
        }

        > .type-title {
            color: white;
            font-weight: bold;
            margin-bottom: 15px;
            padding: 0 4px;
            font-size: 1.2rem;
            display: flex;
            justify-content: flex-start;
            align-content: center;

            > #add-custom-block {
                margin-left: auto;
                font-size: 18px;
                cursor: pointer;
            }
        }

        .type-sub-title {
            color: white;
            font-weight: bold;
            padding: 0 4px;
        }

        > .message {
            padding: 0 4px;
            margin-top: 8px;
        }

        .type-subtitle {
            padding: 0 4px;
            margin-bottom: 5px;
            color: white;
            font-weight: bold;
        }

        .control-name {
            display: grid;
            grid-template-columns: 22px 1fr 16px;
            grid-template-rows: 25px;
            align-items: center;
            padding: 0 4px;
            cursor: pointer;
            position: relative;
            font-size: 1rem;
            transition: all 0.05s ease-in;
            width: 100%;

            &.disabled {
                opacity: 0.5;
                cursor: not-allowed;
            }

            &:hover {
                transition: all 0.05s ease-in;
            }

            &:hover:before {
                content: '';
                position: absolute;
                display: flex;
                width: 100%;
                height: 100%;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                background: rgb(54, 54, 54);
                border-radius: 5px;
                z-index: -1;
            }

            &--prominent {
                color: white;
                grid-template-columns: 22px 1fr;

                &:before {
                    content: '';
                    position: absolute;
                    display: flex;
                    width: 100%;
                    height: 100%;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    background: rgb(45, 45, 45);
                    border-radius: 5px;
                    z-index: -1;
                }

                &:hover {
                    background: none;

                    &:before {
                        background: rgb(54, 54, 54);
                    }
                }
            }

            + .control-name {
                margin-top: 2px;
            }

            .control-label {
                display: flex;
                align-items: center;
                font-size: 13px;
                line-height: 1.2;
            }

            .control-label--new {
                color: white;
                background: var(--color-accent);
                border-radius: 5px;
                padding: 3px 8px;
                font-size: 0.8rem;
                margin-left: auto;
            }

            &[data-name="custom-block"] {
                grid-template-columns: 1fr 22px 22px;

                > .control-label {
                    padding-right: 7px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }

            &[data-name="product-block"] {
                grid-template-columns: 1fr 22px;
                padding-right: 20px;

                > .control-label {
                    padding-right: 7px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    height: 100%;
                }

                .material-symbols-outlined {
                    font-size: 16px;
                }
            }

            > i,
            > .v-icon {
                font-size: 18px;
                color: var(--font-default-color);

                &.delete-custom-block-btn {
                    &:hover {
                        color: var(--color-danger);
                    }
                }

                &.edit-custom-block-btn {
                    &:hover {
                        color: var(--color-accent);
                    }
                }
            }
        }
    }
}

</style>